import MainStyle from "components/UI/main.module.scss";
import { useState } from 'react';

// This will manage the modal state globally
let showInfoMessageCallback = null;
let hideInfoMessageCallback = null;

export const useInfoMsgModal = () => {
  return { showInfoMessage: showInfoMessageCallback, hideInfoMessage: hideInfoMessageCallback };
};

export const InfoMessageModalLocale = () => {
  const [displayModal, setDisplayModal] = useState(false);
  const [messageBody, setMessageBody] = useState({ header: '', message: '' , labelAction: ''});

  // Assign the callbacks globally to control the modal.
  showInfoMessageCallback = ({ header, message, labelAction }) => {
    setMessageBody({ header, message, labelAction });
    setDisplayModal(true);
  };
  hideInfoMessageCallback = () => setDisplayModal(false);

  const closePopUp = () => setDisplayModal(false);

  return (
    <>
      {displayModal && (
        <div className={[MainStyle.modal].join(" ")}>
          <div className={[MainStyle.modal_dialog].join(" ")}>
            <div className={[MainStyle.modal_content, MainStyle.rounded_3, MainStyle.shadow_sm, MainStyle.border, MainStyle.bg_card, MainStyle.mx_3].join(" ")}>
              <div className={MainStyle.m_3}>
                <div className={MainStyle.modal_header}>
                  <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_4, MainStyle.fw_semibold].join(" ")}>
                    {messageBody.header}
                  </span>
                </div>
                <div className={[MainStyle.modal_body, MainStyle.mb_3].join(" ")}>
                  <div className={MainStyle.overflow_y_scroll} style={{maxHeight: '500px'}}>
                    <span className={[MainStyle.text_body, MainStyle.fs_6].join(" ")}>
                      {messageBody.message}
                    </span>
                  </div>
                </div>
                <div className={MainStyle.modal_footer}>
                  <button
                    className={[MainStyle.btn_blue, MainStyle.rounded_3, MainStyle.border, MainStyle.shadow_sm, MainStyle.fs_6, MainStyle.text_white, MainStyle.py_2, MainStyle.px_5].join(" ")}
                    onClick={closePopUp}
                  >
                    {messageBody.labelAction}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

